var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',{staticClass:"hapus-dokter elipsis-item",on:{"click":function($event){$event.preventDefault();return _vm.deleteEmit.apply(null, arguments)}}},[_c('div',{staticStyle:{"width":"22px"}},[_c('TrashIcon',{attrs:{"strokeColor":'#C2283C'}})],1),_c('p',[_vm._v(" Hapus Klinik ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }